import Icon from '~/components/Icon';

import styles from './AppStoreLinks.module.css';

const APP_STORE_HREF = 'https://apps.apple.com/gb/app/oddschecker-sports-betting/id1114487306';
const GOOGLE_PLAY_HREF = 'https://play.google.com/store/apps/details?id=com.oddschecker.app&hl=en_GB';

export const AppStoreLinks = () => {
  return (
    <div className={styles.appStoreLinks} data-testid="app-store-links">
      <span className={styles.tagLine}>Download the app</span>
      <div className={styles.linksContainer}>
        <a
          aria-label="Download on the App Store"
          data-testid="app-store-link"
          href={APP_STORE_HREF}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon icon="AppStore" />
        </a>
        <a
          aria-label="Get it on Google Play"
          data-testid="google-play-link"
          href={GOOGLE_PLAY_HREF}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon icon="GooglePlay" />
        </a>
      </div>
    </div>
  );
};
